import { STRINGS } from "./strings";
import { LIST_TYPES } from "../listTypes";
import ScrollList from "../ScrollList";

const CaseStatusDashFilter = ({ caseStatusCounts, filters, updateFilter, getFilterUIState, setFilterUIState }) => {

  return (
    <div
      id="Case-Status-Dashboard-Filter"
      data_testid="Case-Status-Dashboard-Filter"
      className="overflow-y-auto"
    >
      <ScrollList
        key={"overall_status"}
        array={caseStatusCounts}
        type={LIST_TYPES.BUTTON_LIST}
        statusType="overall_status"
        color="purple"
        filters={filters}
        updateFilter={updateFilter}
        getFilterState={getFilterUIState}
        setFilterState={setFilterUIState}
      />
    </div>
  );
};

export default CaseStatusDashFilter;